export const colors = {
  primary: "#036242", // levissima color
  secondary: "#D02963", // same as missions => act
  tertiary: "#5C997A",
  disabled: "#B4D0C2", // levissima color + 50% white
  background: "#EFF5F2", // levissima background
  backgroundLight: "#F2F3F4",
  backgroundGray: "#F2F3F4", // 100% white
  backgroundWhite: "#FFFFFF", // 100% white
  stroke: "#7D8D96", // Japanese Indigo + 40% white
  text: "#575757", // Japanese Indigo
  textSecondary: "#526773", // Japanese Indigo + 20% white
  textWhite: "#FFFFFF", // 100% white
  metrics: {
    co2: "#759357",
    water: "#5D82CA",
    energy: "#CE9256",
  },
  missions: {
    act: "#14856F",
    learn: "#D02963",
    measure: "#54428E",
  },
  success: "#008000",
  error: "#D02929",
}
